<template>
  <div class="roadblock proud-customer-variant">
    <div class="roadblock-content">
      <div class="cta">
        <!-- Added slot to easily change this content -->
        <slot>
          <div>
            <h5>Join the marketplace trusted by 1M+ creators & entrepreneurs</h5>
            <p>
              “<strong>I have been a proud repeat customer for years.</strong> I have bought
              email marketing, copywriting, and social media solutions that drastically cut
              down our learning curve and brought in much needed clients!”
            </p>
          </div>
        </slot>
        <form v-if="!isEmailSubmitted" @submit.prevent="$_asyncSubmitEmail">
          <input
            v-model="emailAddress"
            type="email"
            name="email"
            placeholder="Email"
            aria-label="Email"
          >
          <button
            type="submit"
            :disabled="isProcessing"
          >
            <slot name="button">
              <span>Don't miss a deal</span>
            </slot>
          </button>
        </form>
        <div v-if="isEmailSubmitted" class="success">
          <img src="~/static/success-tick.svg" alt="">
          <span>
            <b>You're in!</b>  Thanks for signing up.
          </span>
        </div>
      </div>
      <div class="image">
        <div>
          <h5>Precious L. Williams</h5>
          <p>Founder of Perfect Pitches by Precious, LLC</p>
        </div>
        <img
          src="~/static/email-capture-precious.png"
          alt="Discover, buy, & sell"
        >
      </div>
    </div>
  </div>
</template>
<script>
import SubmitEmailMixin from '../../mixins/submit-email';

export default {
  mixins: [SubmitEmailMixin],
};
</script>

<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.roadblock {
  background: #f5f5f9;
  margin-bottom: 60px;
  margin-left: -30px;
  margin-right: -30px;
  padding: 32px 64px;
  overflow: hidden;
}

.roadblock-content {
  display: flex;
  flex-direction: column;
  position: relative;

  form {
    display: flex;
    align-content: center;
    justify-content: center;
  }
}

.image {
  flex: 1 0 0;
  padding-left: 16px;
  position: relative;
}

.roadblock.proud-customer-variant .roadblock-content::before {
  content: '';
  position: absolute;
  background: url(~/static/email-capture-precious.svg) no-repeat;
  top: -32px;
  right: -100px;
  bottom: -32px;
  width: 100%;
  background-position: right center;
  background-size: contain;
  z-index: 0;
}

.image img {
  max-height: 320px;
  width: 100%;
}

.cta h5 {
  font-family: Barlow, sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
}

.cta p {
  font-size: 16px;
  line-height: 24px;
}

.image div {
  width: 170px;
  position: absolute;
  top: 0;
  left: 0;

  h5 {
    font-size: 16px;
    line-height: 24px;
  }

  p {
    font-size: 14px;
    line-height: 20px;
  }
}

.success {
  background: #0a840a;
  padding: 16px 20px;
  color: #fff;
  display: inline-flex;
  align-items: center;
}

.success img {
  margin-right: 16px;
}

.cta {
  flex: 1 0 0;
  z-index: 1;
}

.cta h5 span {
  color: #07c93b;
}

.cta input {
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #000;
  font-size: 16px;
  padding: 6px 12px;
  flex-grow: 1;
}

.cta button {
  background: #ffbc00;
  border-radius: 40px;
  color: #1b1b1b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 24px;
  text-decoration: none;
  border: 0;
  margin-left: 8px;
  text-align: center;
  white-space: nowrap;
}

.cta button:focus {
  border: 0;
  outline: none;
}

.cta button:disabled {
  color: rgba(27, 27, 27, 0.5);
}

.proud-customer-variant {
  background: #fff6ec;

  .image {
    flex: 0 0 0;
    position: relative;
  }

  .cta h5 {
    margin-bottom: 24px;
  }

  .cta p {
    font-size: 18px;
    line-height: 27px;
  }
}

@include media-breakpoint-up(sm) {
  .roadblock-content {
    align-items: center;
    flex-direction: row;
    margin: 0 auto;
    max-width: 1140px;
  }

  .proud-customer-variant {
    .image {
      margin-left: 60px;
    }

    .image img {
      width: auto;
      max-height: unset;
      min-height: 400px;
      margin-bottom: -32px;
    }
  }
}

@include media-breakpoint-down(xs) {
  .cta {
    order: 2;

    form {
      flex-direction: column;
    }
  }

  .image {
    order: 1;
    margin-bottom: 35px;
  }

  .image img {
    margin: 0 auto;
    display: block;
  }

  .roadblock.proud-customer-variant {
    .cta h5 {
      display: none;
    }

    .roadblock-content::before {
      background-size: 110%;
      right: -80px;
      width: calc(100% + 80px);
      background-position: -10px top;
    }

    .image {
      margin-bottom: 24px;
    }

    .image img {
      max-height: 380px;
      width: auto;
      margin-right: -40px;
    }
  }
}

@include media-breakpoint-down(md) {
  .roadblock {
    margin-left: -20px;
    margin-right: -20px;
    padding: 32px;

    &.proud-customer-variant {
      padding-bottom: 80px;
    }
  }

  .cta h5 {
    font-size: 28px;
    line-height: 32px;
  }

  .cta input {
    width: 100%;
  }

  .cta button {
    margin: 16px 0 0;
    width: 100%;
  }
}

@media (min-width: 1024px) {
  .image img {
    height: 280px;
  }
}
</style>
